import { Divider as MuiDivider } from "@mui/material";
import Box from "@mui/material/Box";
import { spacing } from "@mui/system";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
import { LeftSidebar as NavFrame } from "layout-blueprints";
import { get as getAccountDisconnects } from "../../modules/accountDisconnects/api/actions";
import AccountDisconnectsTable from "../../modules/accountDisconnects/components/Table";
import { get as getMeters } from "../../modules/meter/api/actions";

import {
  getAllAccountStatusCodes,
  getAllCustomerTypes,
  getAllPropertyPreviews,
} from "../../modules/apl/api/actions";

const Divider = styled(MuiDivider)(spacing);

const AccountDisconnectsPage = (props) => {
  useEffect(() => {
    //props.getAccountDisconnects();
    //props.getAccounts();
    //props.getMeters();
    props.getAllCustomerTypes();
    props.getAllAccountStatusCodes();
    props.getAllPropertyPreviews();
    document.title = "Ubil+ Disconnects Search";
  }, [props.user.details]);

  const getAccountDisconnects = () => {
    // todo: refresh account disconnects
  };

  return (
    <NavFrame page={"Account Disconnects Page"}>
      <StandardHeader title="Account Disconnects Management" />
      <Divider className="mb-3 mt-3" />
      <Box sx={{ width: '100%' }}>
        {props.user.details.disconnects || props.user.details.isSuperUser ? ( 
        <AccountDisconnectsTable onUpdate={getAccountDisconnects} />) : (
          <p>You do not have the required permisson to view disconencts</p>
        )
        }
      </Box>
    </NavFrame>
  );
};

AccountDisconnectsPage.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  getAccountDisconnects: PropTypes.func.isRequired,
  //getAccounts: PropTypes.func.isRequired,
  getMeters: PropTypes.func.isRequired,
  getAllPropertyPreviews: PropTypes.func.isRequired,
  getAllAccountStatusCodes: PropTypes.func.isRequired,
  getAllCustomerTypes: PropTypes.func.isRequired,
};

// Component State
function AccountDisconnectsPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    accountDisconnects: state.accountDisconnects,
  };
}

export default connect(AccountDisconnectsPageState, {
  getAccountDisconnects,
  //getAccounts,
  getMeters,
  getAllPropertyPreviews,
  getAllAccountStatusCodes, getAllCustomerTypes
})(AccountDisconnectsPage);
